import adminModuleState from "./adminModule/state";
import subscription from "./subscription/state";

export default {
  ...adminModuleState,
  ...subscription,
};
